ux-iws-sf-page {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: stretch;
    width: 100%;
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    background-image: var(--ux-sf-background-image, none);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;

    @media (max-width: 767px) {
        ux-button {
            width: 100%;
        }
    }
}

.ux-iws-sf-page {
    &__sidebar {
        flex: 1 0 auto;
        display: none;
    }

    &__inner {
        flex: 1 1 auto;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        width: 100%;
        height: 100%;
        gap: 30px;
        box-sizing: border-box;
        margin: 0;
        padding: 60px 15px;

        @media (min-width: 400px) {
            padding: 60px calc(100% / 12);
        }
    }
}

ux-iws-sf-page[variant^="center"] .ux-iws-sf-page__inner {
    justify-content: center;
    align-items: center;
}

ux-iws-sf-page[full-height] .ux-iws-sf-page__inner {
    min-height: 100vh;
}

ux-iws-sf-page[data-sidebar="true"] .ux-iws-sf-page__sidebar {
    display: block;

    @media (max-width: 767px) {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        pointer-events: none;
    }
}
